import BlogTopicsList from "./BlogTopicsList";
import BlogTopicEdit from "./BlogTopicEdit";
import BlogTopicCreate from "./BlogTopicCreate";

export default {
    list: BlogTopicsList,
    edit: BlogTopicEdit,
    create: BlogTopicCreate,
};
